import { useEffect, useState } from "react";
import api, { formatMoney } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { FileText } from "lucide-react";

export default function MyPayslips() {
  const [list, setList] = useState([]);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/me/payslips"); setList(data); } catch {}
    })();
  }, []);

  const downloadPdf = async (id) => {
    try {
      const res = await api.get(`/payslips/${id}/pdf`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url, "_blank");
    } catch { toast.error("Failed to fetch PDF"); }
  };

  return (
    <div className="space-y-6" data-testid="me-payslips">
      <div>
        <div className="font-mono text-[10px] tracking-widest uppercase text-zinc-500 mb-2">My space</div>
        <h1 className="font-heading text-4xl font-black tracking-tight">My Payslips</h1>
        <p className="text-sm text-zinc-500 mt-1">Download your monthly salary statements.</p>
      </div>
      <div className="bg-white border border-zinc-200 rounded-sm">
        <Table>
          <TableHeader>
            <TableRow className="bg-zinc-50 hover:bg-zinc-50">
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Payslip</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Month</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 text-right">Gross</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 text-right">Net</TableHead>
              <TableHead className="text-right"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center py-12 text-sm text-zinc-500">No payslips yet.</TableCell></TableRow>
            )}
            {list.map((p) => (
              <TableRow key={p.id} className="hover:bg-zinc-50">
                <TableCell className="font-mono text-xs">{p.payslip_no}</TableCell>
                <TableCell className="font-mono text-xs">{p.month}</TableCell>
                <TableCell className="text-right font-mono text-sm">{formatMoney(p.gross, p.currency)}</TableCell>
                <TableCell className="text-right font-mono text-sm font-semibold">{formatMoney(p.net, p.currency)}</TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="ghost" onClick={() => downloadPdf(p.id)}>
                    <FileText className="h-3.5 w-3.5 mr-1" /> <span className="text-xs font-mono uppercase tracking-widest">PDF</span>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
